<template>
  <div id="album">
    <router-link class="router" :to="{ name: 'MyPost', params: { token: this.$route.params.token } }">
      <p>我的友圈</p>
      <i class="far fa-greater-than"></i>
    </router-link>
    <AlbumPictureSwipe></AlbumPictureSwipe>
  </div>
</template>

<script>
import AlbumPictureSwipe from '@/components/Album/AlbumPictureSwipe';
export default {
  components: {
    AlbumPictureSwipe
  }
};
</script>

<style scoped lang="scss">
body {
  color: #818181;
}
.router {
  display: flex;
  width: 100px;
  height: 40px;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
  margin-right: 2.5vw;
  p {
    color: #337ab7;
    font-size: 16px;
    margin: 0 1vw 0 0;
  }
  i {
    font-size: 16px;
    color: #ccc;
    margin-bottom: 3px;
  }
}
</style>
<style>
.iOSstyle img.pswp__img {
  top: -7vh
}
</style>